import { ProductAddOnsResponse } from 'services/api/responses/responseTypes';
import { IProductAddOnsInfo } from './IProductAddOnsInfo';

export default class ProductAddOnsInfo implements IProductAddOnsInfo {
  distributionIncluded: boolean;

  constructor(data: ProductAddOnsResponse) {
    this.distributionIncluded = data.distribution_included;
  }
}
